export const FAQ_PATH = "/parents/faq";

/**
 * Full FAQ path for window.open / location.
 * @return {string} e.g. "/parents/faq"
 */
export function getFaqPathWithQuery() {
  return FAQ_PATH;
}
